function loadCommonStyles() {
  return new Promise(resolve => {
    const commonStyles = System.resolve('css/common');
    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', commonStyles);
    document.head.appendChild(link);

    link.addEventListener('load', resolve);
  });
}

/* eslint-disable no-unused-vars */
(function () {
  Promise.all([
    System.import('vue'), //0
    System.import('single-spa'), //1
    System.import('single-spa-vue'), //2
    System.import('single-spa-layout'), //3
    System.import('atatus-spa'), //4
    System.import('appsettings'), //5
    loadCommonStyles(), //4
  ]).then(function (modules) {
    const firstToMount = '@mdgld/layout-ui';
    System.set(System.resolve('vue'), window.Vue);
    const Vue = modules[0];
    const singleSpa = modules[1];
    const singleSpaVue = modules[2];
    const singleSpaLayout = modules[3];
    const atatus = modules[4];
    const appsettings = modules[5].default;

    window.logger = function (message) {
      window.logInformation({
        info: message,
      });
    };

    function handleGlobalError(event, type) {
      if (event.message?.includes('LOADING_SOURCE_CODE')) {
        return;
      }

      if (!window?.logError) {
        return;
      }

      window?.logError({
        error: event.error?.message,
        stack: event.error?.stack,
        endpoint: 'pulse',
        type,
      });
    }

    window.addEventListener('error', event =>
      handleGlobalError(event, 'error')
    );

    window.addEventListener('unhandledrejection', event =>
      handleGlobalError(event, 'unhandledrejection')
    );

    const mapping = {
      '@mdgld/authentication-ui': 'css/authentication',
      '@mdgld/layout-ui': 'css/layout',
      '@mdgld/systemadmin-ui': 'css/systemadmin',
      '@mdgld/service-ui': 'css/service',
      '@mdgld/navbar-ui': 'css/navbar',
    };

    singleSpa.addErrorHandler(err => {
      if (
        singleSpa.getAppStatus(err.appOrParcelName) === singleSpa.LOAD_ERROR
      ) {
        System.delete(System.resolve(err.appOrParcelName));
      }
    });

    const firstToMountStyles = System.resolve(mapping[firstToMount]);

    singleSpa.registerApplication(
      firstToMount,
      () => System.import(firstToMount),
      location => true,
      {
        assetsUrl: firstToMountStyles,
      }
    );

    const routes = singleSpaLayout.constructRoutes(
      document.querySelector('#single-spa-layout')
    );

    let applications = singleSpaLayout.constructApplications({
      routes,
      loadApp({ name }) {
        return System.import(name);
      },
    });
    singleSpaLayout.constructLayoutEngine({ routes, applications });

    applications = applications.filter(a => a.name !== firstToMount);

    applications.forEach(app => {
      let appStyles = '';

      if (mapping[app.name]) {
        appStyles = System.resolve(mapping[app.name]);
      }

      singleSpa.registerApplication({
        name: app.name,
        app: () => System.import(app.name),
        activeWhen: location => {
          if (app.name === '@mdgld/systemadmin-ui') {
            return (
              location.pathname.indexOf('/systemadmin') === 0 ||
              location.pathname.indexOf('/manage-users') === 0 ||
              location.pathname.indexOf('/approvals') === 0
            );
          }
          return app.activeWhen[0](location);
        },
        customProps: {
          assetsUrl: appStyles,
          atatus,
        },
      });
    });

    atatus
      .config(appsettings.atatus.apiKey, appsettings.atatus.config)
      .install();

    singleSpa.start();
  });
})();
